import React from "react";

export default function LoadingPage1() {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-grow text-muted"></div>
    </div>
  );
}
